import React, { useState } from 'react';
import { useIntl } from 'react-intl';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import {
  TextField,
  InputAdornment,
  IconButton,
  Typography,
} from '@mui/material';

const useStyles = () => ({
  lgtextfield: {
    mb: '16px',
    '& .MuiOutlinedInput-root': {
      borderRadius: '10px',
      '& fieldset': {
        border: '2px solid #d6d6d6',
      },
    },
    helpertxt: {
      marginLeft: 'unset',
    },
  },
  fieldCaption: {
    fontSize: '1rem',
  },
});

export default function InputPassword({
  register,
  error = null,
  name = null,
  label = 'password',
  fullWidth = false,
  visibility = true,
  customValidation = null,
}) {
  const intl = useIntl();
  const classes = useStyles();
  const [showPwd, setShowPwd] = useState(true);

  return (
    <>
      {visibility && (
        <Typography
          variant="subtitle2"
          sx={classes.fieldCaption}
          color="textSecondary"
        >
          {label}
        </Typography>
      )}
      <TextField
        {...register(name, {
          required: intl.messages.MANDATORY_FIELD,
          validate: customValidation,
        })}
        id={name}
        name={name}
        error={error}
        variant="outlined"
        autoComplete="new-password"
        type={!showPwd ? 'text' : 'password'}
        fullWidth={fullWidth}
        helperText={error?.message}
        sx={classes.lgtextfield}
        style={{ display: !visibility ? 'none' : '' }}
        slotProps={{
          input: {
            endAdornment: (
              <InputAdornment position="end">
                <IconButton
                  onClick={() => setShowPwd(!showPwd)}
                  edge="end"
                  tabIndex={-1}
                >
                  {!showPwd ? (
                    <VisibilityOff sx={{ color: 'inherit' }} />
                  ) : (
                    <Visibility sx={{ color: 'inherit' }} />
                  )}
                </IconButton>
              </InputAdornment>
            ),
          },
        }}
      />
    </>
  );
}
